import {
  type CourseSlice,
  type LearningPathSlice,
  type LessonSlice,
  type ModuleSlice,
  type SlideSlice,
  type WorkoutSlice,
} from "./data.types";

export type State = {
  learningPath: Record<LearningPathSlice["id"], LearningPathSlice>;
  course: Record<CourseSlice["id"], CourseSlice>;
  module: Record<ModuleSlice["id"], ModuleSlice>;
  lesson: Record<LessonSlice["id"], LessonSlice>;
  workout: Record<WorkoutSlice["id"], WorkoutSlice>;
  slide: Record<SlideSlice["id"], SlideSlice>;
};

export const initialState: State = {
  learningPath: {},
  course: {},
  module: {},
  lesson: {},
  workout: {},
  slide: {},
};
